"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const trans_1 = require("@common/tsutils/trans");
const UIRadio2_vue_1 = __importDefault(require("@becrop/components/Toolkit/Heatmap2/vue/UI/UIRadio2.vue"));
let RankingDirection = class RankingDirection extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.options = [
            {
                value: 'asc',
                label: (0, trans_1.trans)('toolkit.metrics_boxplot.vr.dir_a')
            },
            {
                value: 'desc',
                label: (0, trans_1.trans)('toolkit.metrics_boxplot.vr.dir_d')
            },
        ];
    }
    changeDirection(d) {
        this.$emit('changeDirection', d);
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)()
], RankingDirection.prototype, "isDescSorted", void 0);
RankingDirection = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: {
            UIRadio2: UIRadio2_vue_1.default
        }
    })
], RankingDirection);
exports.default = RankingDirection;
